import createIcon from '../../createIcon';

/**
 * @component @name PieChartOutline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjUgMiAyIDYuNSAyIDEyQzIgMTcuNSA2LjUgMjIgMTIgMjJDMTcuNSAyMiAyMiAxNy41IDIyIDEyQzIyIDYuNSAxNy41IDIgMTIgMlpNMTMgNC4wN0MxNi42MSA0LjUyIDE5LjQ4IDcuNCAxOS45MyAxMUgxM1Y0LjA3Wk00IDEyQzQgNy45NCA3LjA3IDQuNTYgMTEgNC4wN1YxOS45NEM3LjA3IDE5LjQ0IDQgMTYuMDYgNCAxMlpNMTMgMTkuOTNWMTNIMTkuOTNDMTkuNDggMTYuNjEgMTYuNjEgMTkuNDggMTMgMTkuOTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PieChartOutline = createIcon('PieChartOutline', [
  [
    'path',
    {
      d: 'M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM13 4.07C16.61 4.52 19.48 7.4 19.93 11H13V4.07ZM4 12C4 7.94 7.07 4.56 11 4.07V19.94C7.07 19.44 4 16.06 4 12ZM13 19.93V13H19.93C19.48 16.61 16.61 19.48 13 19.93Z',
      key: '1jjj5w',
    },
  ],
]);

export default PieChartOutline;
